export default __webpack_public_path__ + "static/segoe.d4762843.svg";